import React from 'react';
import { motion } from 'framer-motion';
import { FaCamera, FaVideo, FaEdit, FaPalette, FaUserFriends, FaLightbulb } from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <FaCamera />,
      title: 'Photography',
      description: 'Professional photography services for weddings, events, portraits, and commercial projects.',
      features: ['Event Coverage', 'Portrait Sessions', 'Product Photography', 'Real Estate']
    },
    {
      icon: <FaVideo />,
      title: 'Videography',
      description: 'Cinematic video production for weddings, corporate events, commercials, and documentaries.',
      features: ['Event Films', 'Corporate Videos', 'Commercials', 'Documentaries']
    },
    {
      icon: <FaEdit />,
      title: 'Post-Production',
      description: 'Expert editing and retouching services to bring out the best in every shot.',
      features: ['Color Grading', 'Photo Retouching', 'Video Editing', 'Visual Effects']
    },
    {
      icon: <FaPalette />,
      title: 'Creative Direction',
      description: 'Conceptualization and creative direction for your visual storytelling needs.',
      features: ['Concept Development', 'Storyboarding', 'Art Direction', 'Brand Consulting']
    },
    {
      icon: <FaUserFriends />,
      title: 'Team Coverage',
      description: 'Multiple photographers and videographers for comprehensive event coverage.',
      features: ['Multi-Camera Setup', 'Full Coverage', 'Team Coordination', 'Live Streaming']
    },
    {
      icon: <FaLightbulb />,
      title: 'Consultation',
      description: 'Expert advice on planning your shoot, selecting locations, and achieving your vision.',
      features: ['Pre-Production', 'Location Scouting', 'Budget Planning', 'Timeline Creation']
    }
  ];

  return (
    <section id="services" className="services">
      <div className="services-container">
        <motion.div
          className="services-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Our Services</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Comprehensive visual solutions tailored to your needs
          </p>
        </motion.div>

        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
